<template>
  <div class="container">
    <div class="title">课程升级确认协议
    </div>
    <div class="s-title">（大米网校课程升级为“VIPKID数学”课）</div>
    <div class="sub-title"><b>感谢您对大米网校的认可和支持，为了给您带来更好的学习体验，我们计划将大米网校课程升级为VIPKID数学课（原VIPKID数学思维课），升级后您将享受到互动性、趣味性更强的课程内容。</b></div>
    <div style="height:20px;width:100vw;"></div>
    <div class="desc">请您务必审慎阅读、充分理解本协议（共5条）各条款内容，<b>可能影响您权益的条款已以加粗形式提示您注意，您应重点阅读。</b>当您按照页面提示确认同意课程升级后，即表示您已充分阅读、理解并接受本升级协议所有条款内容。</div>
    <div style="height:20px;width:100vw;"></div>
    <div class="desc">1、您同意将大米网校账户剩余的大米网校一年级数学春季班课程（简称“大米网校课程”）升级为VIPKID数学课：</div>
    <div class="desc"><b>（1）您账号剩余的8课次（讲）大米网校课程可升级为11课时VIPKID数学课。</b></div>
    <div class="desc"><b>（2）大米网校课程升级为VIPKID数学课后，将无法换回为大米网校课程。</b></div>
    <div class="desc">2、课程退费规则</div>
    <div class="desc">如您将大米网校课程升级为VIPKID数学课后，不想继续学习VIPKID数学课，您需在升级的VIPKID数学课全部使用完毕前提出退费。退费金额计算方式及退费规则如下：</div>
    <div class="desc"><b>（1）您提出退费申请时，使用的VIPKID数学课时数≤3，则将为您退还8课次（讲）大米网校课程对应的全部费用；</b></div>
    <div class="desc"><b>（2）您提出退费申请时，使用的VIPKID数学课课时数＞3，则将按照剩余的VIPKID数学课课时数，以1:1的比例换算为大米网校课程，然后为您退还剩余大米网校课程对应的费用。</b></div>
    <div class="desc"><b>（3）退费金额=剩余的大米网校课次（讲）数×每课次（讲）单价，每课次（讲）单价=已支付的大米网校课程全额费用÷已购大米网校课次（讲）数（不包含赠课）。</b></div>
    <div class="desc">（4）退费将按照您的购买付费路径由大米网校（运营主体为北京文渊佳科技有限公司）原路退回。若因支付渠道的原因导致款项无法原路退回，您需提供相应证明材料（包括但不限于身份证明、银行卡信息等），我们按您所提供的银行卡进行退费操作。</div>
    <div class="desc">（5）如您购买大米网校程时开具纸质版发票的，您退费时需退还购买课时已开具的纸质发票（如不能完好退回，我们将扣除发票金额的8%以支付未退还发票产生的相关费用）。</div>
    <div class="desc">3、VIPKID数学课课程规则</div>
    <div class="desc">（1）VIPKID数学课运营及服务主体为北京大米科技有限公司(简称“VIPKID”)。</div>
    <div class="desc"><b>（2）VIPKID数学课为一对多的在线视频课程服务，即由一位授课老师向多位学员通过在线视频提供的课程服务。</b></div>
    <div class="desc"><b>（3）VIPKID数学课为固定排课，如果学员无法在预定时间进入教室，将视为缺席，课程将按时开始和结束，学员及您不能要求课程延时或改期。如果您提出退费，每次因缺席被扣除的课时都将视为已使用的课时。</b></div>
    <div class="desc"><b>（4）使用VIPKID数学课过程中，您获取的任何赠送课程均为免费赠送，在任何情形下均无法申请退费。</b></div>
    <div class="desc">（5）您或学员如有以下情形，我们或教师有权中止课程，且扣除该次课程；同时我们有权删除该次课程的全部视频：</div>
    <div class="warning">a.非学员本人上课，包括但不限于多个孩子上课或由非学员本人上课、成人代替上课等；
b.学员本人及进入教学环境的个体有违背公序良俗的着装、发型、语言、动作，包括但不限于裸露身体隐私部位等；
c.家暴行为或者侵犯未成年人合法权益的不适当的管教行为，包括惩罚性的肢体接触或者严重辱骂等身体、精神的侵害行为；
d.危害人身、财产安全，泄露个人隐私；
e.发布和讨论与课程内容无关的言论；
f.使用危险的用具，包括但不限于刀具、仿真枪等；
g.损害国家的尊严或者利益，泄露国家秘密, 颠覆国家政权，破坏国家统一；
h.反对宪法所确定的基本原则的，煽动抗拒、破坏宪法和法律、行政法实施的；
i.损害国家荣誉和利益；
j.散布谣言，扰乱社会秩序，破坏社会稳定的信息；
k.有淫秽、色情、赌博、迷信、恐怖、暴力、宣扬教唆犯罪相关的言行；
l.有民族、种族、宗教相关的言行，破坏民族团结，破坏国家宗教政策；
m.对授课老师进行攻击性、歧视性的言行；
n.有性别歧视的言行，违背社会良好风尚的言行；
o.违反法律、行政法规规定的其他情形。
    </div>
    <div class="desc">4、您同意，在学员参与的所有课程中，或您及学员参与的VIPKID组织、举办的其他活动中，VIPKID可以进行拍照、摄像、录音、录像等记录活动。VIPKID对上述记录活动过程中所产生的作品、录音录像制品等单独地享有全部、完整的知识产权。VIPKID同意依法为您及学员的个人信息采取严格的保密措施。未经您同意，VIPKID不得将上述包含您及学员肖像或者显示个人身份的其他个人信息进行公开地商业使用。仅当以下情况之一发生时，VIPKID可以对您及学员的肖像、姓名等个人信息进行合理使用，无须再单独取得您的同意，也无须向您支付任何费用：（1）您及学员的肖像、姓名等合法民事权益，已被明确放弃；（2）为VIPKID内部的展示/使用需要，包括但不限于在内部会议中展示、将相关资料作为历史档案留存于VIPKID档案库或者服务器上等。</div>
    <div class="desc">5、您确认并同意，升级的VIPKID数学课仅供原大米网校账户下的一名固定学员使用，不得进行全部或部分的转让、出售、赠与或其他处置行为，否则您升级的VIPKID数学课及权益将直接全部取消。</div>
    <div class="position">
      <div v-if="hasmigrate" class="hassubmit-bt">已确认升级课程</div>
      <div v-else class="submit-bt" @click="submitSave">确认升级课程</div>
    </div>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import referralUri from '@/utils/_referral'
import { getMigrateRecord, saveMigrateRecord } from '@/api/migrate'
import { Toast } from 'vant'
// const ENV = process.env.VUE_APP_ENV

export default {
  data () {
    return {
      hasmigrate: false
    }
  },
  created () {

  },
  mounted () {
    if (this.islogin()) {
      this.getMigrateRecord()
    }
  },
  destroyed () {

  },
  methods: {
    submitSave () {
      const parentId = cookie.get('mbparentid')
      const studentId = cookie.get('mbstudentid')
      if (parentId && studentId) {
        this.saveMigrateRecord(studentId)
      } else {
        cookie.remove('mbparentid')
        cookie.remove('mbstudentid')
        window.location.href = referralUri()
      }
    },
    islogin () {
      const parentId = cookie.get('mbparentid')
      const studentId = cookie.get('mbstudentid')
      if (parentId && studentId) {
        return true
      } else {
        return false
      }
    },
    getMigrateRecord () {
      const studentId = cookie.get('mbstudentid')
      getMigrateRecord({
        studentId
      }).then(res => {
        this.hasmigrate = res.data
      })
    },
    saveMigrateRecord () {
      const studentId = cookie.get('mbstudentid')
      saveMigrateRecord({
        studentId: studentId * 1
      }).then(res => {
        Toast(res.message)
        if (res.code === 200) {
          this.hasmigrate = true
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/img/referral/spriteout/sprites.scss";
.container{
  width:750px;
  margin:0 auto;
  padding:10px 55px 150px;
  position:relative;
  overflow-x:hidden;
}
.title{
  font-size:30px;
  color:#111;
  margin-top:20px;
  white-space: pre-line;
  text-align: center;
  line-height:50px;
}
.s-title{
  font-size:28px;
  color:#111;
  white-space: pre-line;
  text-align: center;
  line-height:50px;
}
.sub-title{
  font-size:28px;
  color:#333;
  margin-top:15px;
  line-height:40px;
}
.desc{
  font-size:24px;
  color:#666;
  margin-top:10px;
  line-height:34px;
}
.warning{
  font-size:24px;
  color:#666;
  margin-top:10px;
  line-height:34px;
  white-space: pre-line;
}
.hassubmit-bt{
  height:60px;
  width:240px;
  border-radius: 8px;
  line-height: 60px;
  text-align: center;
  font-size:30px;
  margin:30px auto;
  background:#b1b1b1;
  color:white;
}
.submit-bt{
  height:60px;
  width:240px;
  border-radius: 8px;
  line-height: 60px;
  text-align: center;
  font-size:30px;
  margin:30px auto;
  background:#ec973f;
  color:white;
}
.position{
  position: fixed;
  background: white;
  bottom:0;
  width:100vw;
  left:0;
}
</style>
